import React from "react";
import { container } from "./../../constants/styles";

function Clarity() {
  return (
    <div className="min-h-screen bg-[#f2f3f5]">
      <div className={container}>
        <div className="py-12">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Activate your account to see who owns
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-blue-600 mb-4">
              +48 576 222 583
            </h2>
            <p className="text-gray-600 text-lg">
              Latest report as of July 18, 2025
            </p>
          </div>

          {/* Phone Details Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-12 max-w-2xl mx-auto">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
            </div>
            
            <div className="text-center">
              <h3 className="text-3xl font-bold text-gray-800 mb-4">576 222 583</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-600">
                  <span className="font-semibold">Carrier:</span> Play
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Line Type:</span> mobile
                </p>
              </div>
              <p className="text-sm text-gray-500">
                • Trusted by over 17 million people.
              </p>
            </div>
          </div>

          {/* Trial Offer Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-12 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Try ClarityCheck for 7 days
            </h3>
            
            <div className="text-center mb-6">
              <p className="text-gray-600 mb-4">
                Over 701 reverse phone lookups taken today
              </p>
              <div className="flex justify-center items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
                <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
                <span className="text-sm text-gray-600">Anna</span>
                <span className="text-sm text-gray-600">Fra</span>
                <span className="text-sm text-gray-600">+696</span>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">details</h4>
                
                <div className="space-y-4">
                  <div>
                    <h5 className="font-semibold text-gray-800">Comprehensive Phone Lookups</h5>
                    <p className="text-gray-600 text-sm">
                      Search any phone number to retrieve information about the owner.
                    </p>
                  </div>
                  
                  <div>
                    <h5 className="font-semibold text-gray-800">Your Search History Is Privately Secured</h5>
                    <p className="text-gray-600 text-sm">
                      Rest assured the phone owner will NOT be notified about your search.
                    </p>
                  </div>
                  
                  <div>
                    <h5 className="font-semibold text-gray-800">Our Database Is Updated Daily</h5>
                    <p className="text-gray-600 text-sm">
                      Other services may only receive updates once a month or less.
                    </p>
                  </div>
                  
                  <div>
                    <h5 className="font-semibold text-gray-800">Searching Billions of Records</h5>
                    <p className="text-gray-600 text-sm">
                      The report may contain surprising information. Please be prepared for unexpected results.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-4">
                  Stop wondering who has been calling you and get the facts. For good. Remember, most people don't know this potentially sensitive information is available for you to see
                </p>
              </div>
            </div>
          </div>

          {/* Featured Section */}
          <div className="text-center mb-12">
            <h4 className="text-lg font-semibold text-gray-800 mb-6">
              ClarityCheck has been featured on
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <div className="text-gray-400 text-sm">WICZ</div>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <div className="text-gray-400 text-sm">Globe & Mail</div>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <div className="text-gray-400 text-sm">Benzinga</div>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <div className="text-gray-400 text-sm">Barchart</div>
              </div>
            </div>
          </div>

          {/* Secure Checkout Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-12 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Secure Checkout
            </h3>
            
            <div className="space-y-4 mb-6">
              <p className="text-gray-600">
                • Search any phone number to retrieve information about the owner
              </p>
              <p className="text-gray-600">
                • The phone owner will NOT be notified about your search
              </p>
              <p className="text-gray-600">
                • The report may contain shocking information. Please be prepared for unexpected results.
              </p>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg mb-6">
              <p className="text-gray-700">
                Get a 7-day trial for just €1.00. After trial, we'll charge €14.99 every week until you cancel.
              </p>
            </div>

            <div className="text-center mb-6">
              <div className="text-lg mb-2">Total due today:</div>
              <div className="text-3xl font-bold mb-2">
                <span className="line-through text-gray-400">€6.67</span>
                <span className="text-green-600 ml-2">€1.00</span>
              </div>
              <div className="text-green-600 font-semibold">You save 85%</div>
            </div>

            <div className="text-center">
              <h4 className="text-lg font-semibold text-gray-800 mb-4">
                CHOOSE YOUR PAYMENT METHOD
              </h4>
              <button className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                Continue to Payment
              </button>
            </div>
          </div>

          {/* Reviews Section */}
          <div className="mb-12">
            <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">
              Thousands Are Finding Clarity with Us
            </h3>
            
            <div className="text-center mb-8">
              <div className="text-yellow-500 text-2xl mb-2">★★★★★</div>
              <div className="text-2xl font-bold text-gray-800">Excellent</div>
              <div className="text-xl font-bold text-gray-800 mb-2">4.75</div>
              <div className="text-gray-600">based on <strong>338</strong> reviews</div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h4 className="font-bold text-gray-800 mb-2">Emily Johnson</h4>
                <p className="text-sm text-gray-600 mb-3">Verified Customer</p>
                <p className="text-gray-700 mb-4">
                  This service was pretty precise and right on target for most of my searches, except, in a few instances when the information seemed somewhat outdated. Yet this is what made everything worthwhile, reconnecting with my old friend.
                </p>
                <p className="text-sm text-gray-500">Aliso Viejo, United States, 1 days ago</p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h4 className="font-bold text-gray-800 mb-2">Brian King</h4>
                <p className="text-sm text-gray-600 mb-3">Verified Customer</p>
                <p className="text-gray-700 mb-4">
                  Service is prompt and the accuracy is spot-on. Super impressed!
                </p>
                <p className="text-sm text-gray-500">Ruckersville, United States, 1 days ago</p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h4 className="font-bold text-gray-800 mb-2">Ethan miller</h4>
                <p className="text-sm text-gray-600 mb-3">Verified Customer</p>
                <p className="text-gray-700 mb-4">
                  Yet another service that has now joined my pantheon of favorite tools for managing who gets to contact me.
                </p>
                <p className="text-sm text-gray-500">Mount Vernon, United States, 30 days ago</p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h4 className="font-bold text-gray-800 mb-2">Jennifer Smith</h4>
                <p className="text-sm text-gray-600 mb-3">Verified Customer</p>
                <p className="text-gray-700 mb-4">
                  This platform is a miracle!
                </p>
                <p className="text-sm text-gray-500">Aliso Viejo, United States, 5 days ago</p>
              </div>
            </div>

            <div className="text-center">
              <div className="text-gray-400 text-sm">Reviews.io</div>
            </div>
          </div>

          {/* Latest Results Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Latest Results
            </h3>
            <p className="text-gray-600 text-center mb-8">
              Here are some of the latest results from our reverse phone lookup service.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-red-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">González Martín</div>
                    <div className="text-sm text-gray-600">+34XXX-XXXX-726</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-red-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">Rodríguez Martín</div>
                    <div className="text-sm text-gray-600">+34XXX-XXXX-746</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-blue-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">Bernard Jean</div>
                    <div className="text-sm text-gray-600">+33XXX-XXXX-800</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-red-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">Martínez Lucía</div>
                    <div className="text-sm text-gray-600">+34XXX-XXXX-704</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-red-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">García Leo</div>
                    <div className="text-sm text-gray-600">+34XXX-XXXX-523</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-red-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">Pérez Martina</div>
                    <div className="text-sm text-gray-600">+34XXX-XXXX-275</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-green-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">Santos Rodrigo</div>
                    <div className="text-sm text-gray-600">+351XXX-XXXX-391</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-6 h-4 bg-green-500 rounded-sm mr-3"></div>
                  <div>
                    <div className="font-semibold text-gray-800">Russo Anna</div>
                    <div className="text-sm text-gray-600">+39XXX-XXXX-905</div>
                  </div>
                </div>
                <div className="text-sm text-gray-500">a minute ago</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Clarity; 